import * as React from "react";
import mindFreeLogo from '../assets/images/Mindfree_Logo.svg';

export const LockOverlayUI = ({ selectedLanguage }) => {
    return (
        <>
            <div
                style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    zIndex: 9999,
                    backgroundColor: "rgba(255, 255, 255, 0.93)",
                    pointerEvents: "all",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    borderRadius: "inherit",
                    gap: "12px",
                }}
            >
                <img src={mindFreeLogo} alt="mind free logo" style={{ width: "120px" }} />
                <p className="m-0 text-center py-0 px-3" style={{ color: "#555", fontSize: "14px" }}>
                    {
                        selectedLanguage == "en-GB" ?
                            "Booking is currently unavailable for the next five minutes due to an update. Please try again later."
                            : selectedLanguage == "fr-BE" ?
                                "La réservation est actuellement indisponible pendant les cinq prochaines minutes en raison d’une mise à jour. Veuillez réessayer plus tard."
                                :
                                "Boeken is momenteel niet beschikbaar gedurende de komende vijf minuten vanwege een update. Probeer het later opnieuw."
                    }
                </p>
            </div>
        </>
    )
}


